import React from 'react';
import styled from 'styled-components';
import { useStandardAlertStore } from '../../shared/store/portal/alertStore';
import { AlertPosition, AlertType } from '../../shared/enum/EnumRepository';
import { paperTextureAlert } from '../../shared/component/paperTexture';


const SystemAlertComp: React.FC = () => {
  const { queue } = useStandardAlertStore();
  if (queue.length === 0) return null;
  const currentStandardAlert = queue[0];

  return (
    <>
    <ModalOverlay $type={currentStandardAlert.type || AlertType.MAINTENANCE} />
    <SystemAlertContent $position={currentStandardAlert.position || AlertPosition.CENTER}>
      <Title>{currentStandardAlert.type === AlertType.EMERGENCY ? 'Temporarily Paused' : 'On Hold'}</Title>
      <Content>{currentStandardAlert.content}</Content>
    </SystemAlertContent>
    </>
  );
};

const ModalOverlay = styled.div <{ $type: AlertType }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.color_Alpha_04};
  display: flex;
  justify-content: center;
  align-items: center; 
  backdrop-filter: ${({ $type }) => $type === AlertType.EMERGENCY ? 'blur(10px)' : 'blur(3px)'};
`;

const SystemAlertContent = styled.div<{ $position: AlertPosition }>`
  position: fixed;
  top: ${({ $position }) => $position === AlertPosition.CENTER ? '40%' : 'calc(10vh)'};
   /* 화면 가운데 정렬 */
  left: 50%;
  transform: translateX(-50%);
  min-width: 400px;
  min-height: 50px;
  width: fit-content;
  height: fit-content;

  padding: 20px;
  ${paperTextureAlert}
`;

const Title = styled.h2`
  margin-bottom: 12px;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  ${({ theme }) => theme.typography.Body_02_1};
`;
const Content = styled.h2`
  margin-bottom: 44px;
  ${({ theme }) => theme.typography.Body_03_2};
`;

export default SystemAlertComp;